// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/sensor-list-schema',
  type: 'object',
  required: ['id', 'creatorId', 'value1', 'value2'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    customer: {
      type: 'string',
      nullable: true,
    },
    project: {
      type: 'string',
      nullable: true,
    },
    object: {
      type: 'string',
      nullable: true,
    },
    sensorId: {
      type: 'string',
      nullable: true,
    },
    sensorTyp: {
      type: 'string',
      nullable: true,
    },
    sensorConfig: {
      type: 'string',
      nullable: true,
    },
    valueHex: {
      type: 'string',
      nullable: true,
    },
    value1: {
      type: 'number',
    },
    unit1: {
      type: 'string',
      nullable: true,
    },
    value2: {
      type: 'number',
    },
    unit2: {
      type: 'string',
      nullable: true,
    },
    measurementTime: {
      type: 'string',
      format: 'date-time',
    },
  },
} as IJSONSchema;

export default schema;
